import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import "@/lib/pwa";
import { checkBuildVersion } from "@/lib/buildCheck";
import { ErrorBoundary } from "@/components/ErrorBoundary";

checkBuildVersion({ startup: true });
document.addEventListener("visibilitychange", () => { if (document.visibilityState === "visible") checkBuildVersion(); });

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 60_000, refetchOnWindowFocus: false } },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </ErrorBoundary>,
);
